import { gql } from '@apollo/client';

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPasswordMutation($resetPasswordInput: AuthResetPasswordInput!) {
    portalAuthResetPassword(resetPasswordInput: $resetPasswordInput) {
      emailAddress
    }
  }
`;
